exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#projects-page{height:100%;display:flex;flex-direction:column;align-items:center}#projects-page .bitmelo-logo{margin-top:8px}#projects-page .current-project{width:608px;padding:16px;margin-top:16px;margin-bottom:32px}#projects-page .current-project .project-name{font-weight:bold;margin:16px;margin-top:8px}", ""]);

